export const SITES_API = "SITES";
